import React from "react";

const HomeVisitClinicalRecordForm = ({
  formData,
  setFormData,
  handleChange,
  errors,
  readOnly = false,
}) => {
  const handleCheckboxChange = (e) => {
    if (readOnly) return;
    const { name, checked } = e.target;
    setFormData((prev) => ({ ...prev, [name]: checked }));
  };

  const handlePhoneChange = (e) => {
    if (readOnly) return;
    const { name, value } = e.target;
    const digits = value.replace(/\D/g, "");
    let formatted = digits;
    if (digits.length > 4) {
      formatted = `${digits.slice(0, 4)}-${digits.slice(4)}`;
    }
    setFormData((prev) => ({ ...prev, [name]: formatted }));
  };

  return (
    <div className="content p-4">
      <div className="accordion" id="clinicalRecordAccordion">
        
        {/* SECTION 1: Visit Information */}
        <div className="accordion-item card mb-3">
          <h2 className="accordion-header" id="headingVisitInfo">
            <button
              className="accordion-button bg-label-primary text-primary fw-bold"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseVisitInfo"
              aria-expanded="true"
              aria-controls="collapseVisitInfo"
            >
              1. Visit Information
            </button>
          </h2>
          <div
            id="collapseVisitInfo"
            className="accordion-collapse collapse show"
            aria-labelledby="headingVisitInfo"
            data-bs-parent="#clinicalRecordAccordion"
          >
            <div className="accordion-body pt-4">
              <div className="row g-3">
                <div className="col-md-4">
                  <div className="form-floating form-floating-outline">
                    <select
                      className={`form-select ${errors?.visit_number ? "is-invalid" : ""}`}
                      name="visit_number"
                      value={formData.visit_number || ""}
                      onChange={handleChange}
                      disabled={readOnly}
                    >
                      <option value="">Select Visit Number</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5</option>
                    </select>
                    <label>Visit Number</label>
                    {errors?.visit_number && <div className="invalid-feedback">{errors.visit_number}</div>}
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="form-floating form-floating-outline">
                    <input
                      type="date"
                      className={`form-control ${errors?.date_of_visit ? "is-invalid" : ""}`}
                      name="date_of_visit"
                      value={formData.date_of_visit || ""}
                      onChange={handleChange}
                      disabled={readOnly}
                    />
                    <label>Date of Visit</label>
                    {errors?.date_of_visit && <div className="invalid-feedback">{errors.date_of_visit}</div>}
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="form-floating form-floating-outline">
                    <select
                      className={`form-select ${errors?.type_of_visit ? "is-invalid" : ""}`}
                      name="type_of_visit"
                      value={formData.type_of_visit || ""}
                      onChange={handleChange}
                      disabled={readOnly}
                    >
                      <option value="">Select Visit Type</option>
                      <option value="Scheduled Follow-up">Scheduled Follow-up</option>
                      <option value="Concluding Visit">Concluding Visit</option>
                      <option value="Emergency Follow-up">Emergency Follow-up</option>
                    </select>
                    <label>Type of Visit</label>
                    {errors?.type_of_visit && <div className="invalid-feedback">{errors.type_of_visit}</div>}
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="form-floating form-floating-outline">
                    <input
                      type="text"
                      className={`form-control ${errors?.time_in ? "is-invalid" : ""}`}
                      name="time_in"
                      value={formData.time_in || ""}
                      onChange={handleChange}
                      disabled={readOnly}
                      placeholder="e.g. 10:00 AM"
                    />
                    <label>Time In</label>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="form-floating form-floating-outline">
                    <input
                      type="text"
                      className={`form-control ${errors?.time_out ? "is-invalid" : ""}`}
                      name="time_out"
                      value={formData.time_out || ""}
                      onChange={handleChange}
                      disabled={readOnly}
                      placeholder="e.g. 11:30 AM"
                    />
                    <label>Time Out</label>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="form-floating form-floating-outline">
                    <input
                      type="text"
                      className={`form-control ${errors?.duration ? "is-invalid" : ""}`}
                      name="duration"
                      value={formData.duration || ""}
                      onChange={handleChange}
                      disabled={readOnly}
                      placeholder="e.g. 1 Hour 30 Mins"
                    />
                    <label>Duration</label>
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="form-floating form-floating-outline">
                    <textarea
                      className="form-control"
                      name="location_address"
                      value={formData.location_address || ""}
                      onChange={handleChange}
                      disabled={readOnly}
                      placeholder="Location Address"
                      style={{ height: "70px" }}
                    />
                    <label>Location Address</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* SECTION 2: TRH Visiting Team */}
        <div className="accordion-item card mb-3">
          <h2 className="accordion-header" id="headingTeam">
            <button
              className="accordion-button collapsed bg-label-primary text-primary fw-bold"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseTeam"
              aria-expanded="false"
              aria-controls="collapseTeam"
            >
              2. TRH Visiting Team
            </button>
          </h2>
          <div
            id="collapseTeam"
            className="accordion-collapse collapse"
            aria-labelledby="headingTeam"
            data-bs-parent="#clinicalRecordAccordion"
          >
            <div className="accordion-body pt-4">
              <div className="row g-3">
                <div className="col-md-6">
                  <div className="form-floating form-floating-outline">
                    <input
                      type="text"
                      className="form-control"
                      name="psychiatrist_name"
                      value={formData.psychiatrist_name || ""}
                      onChange={handleChange}
                      disabled={readOnly}
                      placeholder="Psychiatrist"
                    />
                    <label>Psychiatrist</label>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating form-floating-outline">
                    <input
                      type="text"
                      className="form-control"
                      name="rehab_practitioner_name"
                      value={formData.rehab_practitioner_name || ""}
                      onChange={handleChange}
                      disabled={readOnly}
                      placeholder="Rehabilitation Practitioner"
                    />
                    <label>Rehabilitation Practitioner</label>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating form-floating-outline">
                    <input
                      type="text"
                      className="form-control"
                      name="rehab_assistant_name"
                      value={formData.rehab_assistant_name || ""}
                      onChange={handleChange}
                      disabled={readOnly}
                      placeholder="Rehabilitation Assistant"
                    />
                    <label>Rehabilitation Assistant</label>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating form-floating-outline">
                    <input
                      type="text"
                      className="form-control"
                      name="driver_name"
                      value={formData.driver_name || ""}
                      onChange={handleChange}
                      disabled={readOnly}
                      placeholder="Driver"
                    />
                    <label>Driver</label>
                  </div>
                </div>

                <div className="col-md-12">
                  <label className="form-label d-block text-dark fw-semibold mb-2">Gender-Specific Team:</label>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="team_gender"
                      id="team_gender_male"
                      value="Male Team"
                      checked={formData.team_gender === "Male Team"}
                      onChange={handleChange}
                      disabled={readOnly}
                    />
                    <label className="form-check-label" htmlFor="team_gender_male">Male Team</label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="team_gender"
                      id="team_gender_female"
                      value="Female Team"
                      checked={formData.team_gender === "Female Team"}
                      onChange={handleChange}
                      disabled={readOnly}
                    />
                    <label className="form-check-label" htmlFor="team_gender_female">Female Team</label>
                  </div>
                </div>

                <div className="col-12 mt-4">
                  <h6 className="text-secondary border-bottom pb-2 fw-semibold">Family Member Present (Mandatory)</h6>
                </div>

                <div className="col-md-4">
                  <div className="form-floating form-floating-outline">
                    <input
                      type="text"
                      className="form-control"
                      name="family_member_name"
                      value={formData.family_member_name || ""}
                      onChange={handleChange}
                      disabled={readOnly}
                      placeholder="Family Member Name"
                    />
                    <label>Name</label>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="form-floating form-floating-outline">
                    <input
                      type="text"
                      className="form-control"
                      name="family_member_relation"
                      value={formData.family_member_relation || ""}
                      onChange={handleChange}
                      disabled={readOnly}
                      placeholder="Relation to Patient"
                    />
                    <label>Relation</label>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="form-floating form-floating-outline">
                    <input
                      type="text"
                      className="form-control"
                      name="family_member_contact"
                      value={formData.family_member_contact || ""}
                      onChange={handlePhoneChange}
                      disabled={readOnly}
                      placeholder="Contact Number"
                    />
                    <label>Contact Number</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* SECTION 3: Safety & Environment Check */}
        <div className="accordion-item card mb-3">
          <h2 className="accordion-header" id="headingSafety">
            <button
              className="accordion-button collapsed bg-label-primary text-primary fw-bold"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseSafety"
              aria-expanded="false"
              aria-controls="collapseSafety"
            >
              3. Safety & Environment Check (Before Starting Session)
            </button>
          </h2>
          <div
            id="collapseSafety"
            className="accordion-collapse collapse"
            aria-labelledby="headingSafety"
            data-bs-parent="#clinicalRecordAccordion"
          >
            <div className="accordion-body pt-4">
              <div className="row g-2 mb-3">
                <div className="col-md-12">
                  <div className="form-check mb-2">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="safety_environment_safe"
                      name="safety_environment_safe"
                      checked={!!formData.safety_environment_safe}
                      onChange={handleCheckboxChange}
                      disabled={readOnly}
                    />
                    <label className="form-check-label text-dark" htmlFor="safety_environment_safe">
                      Environment safe for team
                    </label>
                  </div>

                  <div className="form-check mb-2">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="safety_no_weapons"
                      name="safety_no_weapons"
                      checked={!!formData.safety_no_weapons}
                      onChange={handleCheckboxChange}
                      disabled={readOnly}
                    />
                    <label className="form-check-label text-dark" htmlFor="safety_no_weapons">
                      No visible weapons
                    </label>
                  </div>

                  <div className="form-check mb-2">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="safety_no_intoxicated"
                      name="safety_no_intoxicated"
                      checked={!!formData.safety_no_intoxicated}
                      onChange={handleCheckboxChange}
                      disabled={readOnly}
                    />
                    <label className="form-check-label text-dark" htmlFor="safety_no_intoxicated">
                      No intoxicated individuals present
                    </label>
                  </div>

                  <div className="form-check mb-2">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="safety_client_stable"
                      name="safety_client_stable"
                      checked={!!formData.safety_client_stable}
                      onChange={handleCheckboxChange}
                      disabled={readOnly}
                    />
                    <label className="form-check-label text-dark" htmlFor="safety_client_stable">
                      Client medically stable
                    </label>
                  </div>

                  <div className="form-check mb-2">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="safety_family_cooperative"
                      name="safety_family_cooperative"
                      checked={!!formData.safety_family_cooperative}
                      onChange={handleCheckboxChange}
                      disabled={readOnly}
                    />
                    <label className="form-check-label text-dark" htmlFor="safety_family_cooperative">
                      Family cooperative
                    </label>
                  </div>
                </div>
              </div>

              <div className="row g-3">
                <div className="col-12">
                  <div className="form-floating form-floating-outline">
                    <textarea
                      className="form-control"
                      name="safety_unsafe_action_description"
                      value={formData.safety_unsafe_action_description || ""}
                      onChange={handleChange}
                      disabled={readOnly}
                      placeholder="If unsafe, describe action taken"
                      style={{ height: "80px" }}
                    />
                    <label>If unsafe, describe action taken</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* SECTION 4: Current Clinical Status */}
        <div className="accordion-item card mb-3">
          <h2 className="accordion-header" id="headingClinical">
            <button
              className="accordion-button collapsed bg-label-primary text-primary fw-bold"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseClinical"
              aria-expanded="false"
              aria-controls="collapseClinical"
            >
              4. Current Clinical Status (Mental State Overview)
            </button>
          </h2>
          <div
            id="collapseClinical"
            className="accordion-collapse collapse"
            aria-labelledby="headingClinical"
            data-bs-parent="#clinicalRecordAccordion"
          >
            <div className="accordion-body pt-4">
              <div className="row g-3">
                <div className="col-md-6">
                  <div className="form-floating form-floating-outline">
                    <input
                      type="text"
                      className="form-control"
                      name="clinical_appearance_hygiene"
                      value={formData.clinical_appearance_hygiene || ""}
                      onChange={handleChange}
                      disabled={readOnly}
                      placeholder="Appearance & Hygiene"
                    />
                    <label>Appearance & Hygiene</label>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating form-floating-outline">
                    <input
                      type="text"
                      className="form-control"
                      name="clinical_behavior"
                      value={formData.clinical_behavior || ""}
                      onChange={handleChange}
                      disabled={readOnly}
                      placeholder="Behavior"
                    />
                    <label>Behavior</label>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating form-floating-outline">
                    <input
                      type="text"
                      className="form-control"
                      name="clinical_speech"
                      value={formData.clinical_speech || ""}
                      onChange={handleChange}
                      disabled={readOnly}
                      placeholder="Speech"
                    />
                    <label>Speech</label>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating form-floating-outline">
                    <input
                      type="text"
                      className="form-control"
                      name="clinical_mood_affect"
                      value={formData.clinical_mood_affect || ""}
                      onChange={handleChange}
                      disabled={readOnly}
                      placeholder="Mood/Affect"
                    />
                    <label>Mood/Affect</label>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating form-floating-outline">
                    <input
                      type="text"
                      className="form-control"
                      name="clinical_thought_content"
                      value={formData.clinical_thought_content || ""}
                      onChange={handleChange}
                      disabled={readOnly}
                      placeholder="Thought Content (Delusion/Suspicion)"
                    />
                    <label>Thought Content (Delusion/Suspicion)</label>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating form-floating-outline">
                    <input
                      type="text"
                      className="form-control"
                      name="clinical_perception"
                      value={formData.clinical_perception || ""}
                      onChange={handleChange}
                      disabled={readOnly}
                      placeholder="Perception (Hallucinations)"
                    />
                    <label>Perception (Hallucinations)</label>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating form-floating-outline">
                    <input
                      type="text"
                      className="form-control"
                      name="clinical_insight"
                      value={formData.clinical_insight || ""}
                      onChange={handleChange}
                      disabled={readOnly}
                      placeholder="Insight"
                    />
                    <label>Insight</label>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating form-floating-outline">
                    <input
                      type="text"
                      className="form-control"
                      name="clinical_judgment"
                      value={formData.clinical_judgment || ""}
                      onChange={handleChange}
                      disabled={readOnly}
                      placeholder="Judgment"
                    />
                    <label>Judgment</label>
                  </div>
                </div>

                <div className="col-md-4">
                  <label className="form-label d-block text-dark fw-semibold mb-2">Suicidal Ideation:</label>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="clinical_suicidal_ideation"
                      id="suicidal_yes"
                      value="true"
                      checked={formData.clinical_suicidal_ideation === true || formData.clinical_suicidal_ideation === "true"}
                      onChange={() => setFormData((prev) => ({ ...prev, clinical_suicidal_ideation: true }))}
                      disabled={readOnly}
                    />
                    <label className="form-check-label" htmlFor="suicidal_yes">Yes</label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="clinical_suicidal_ideation"
                      id="suicidal_no"
                      value="false"
                      checked={formData.clinical_suicidal_ideation === false || formData.clinical_suicidal_ideation === "false"}
                      onChange={() => setFormData((prev) => ({ ...prev, clinical_suicidal_ideation: false }))}
                      disabled={readOnly}
                    />
                    <label className="form-check-label" htmlFor="suicidal_no">No</label>
                  </div>
                </div>

                <div className="col-md-4">
                  <label className="form-label d-block text-dark fw-semibold mb-2">Homicidal/Aggressive Ideation:</label>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="clinical_homicidal_ideation"
                      id="homicidal_yes"
                      value="true"
                      checked={formData.clinical_homicidal_ideation === true || formData.clinical_homicidal_ideation === "true"}
                      onChange={() => setFormData((prev) => ({ ...prev, clinical_homicidal_ideation: true }))}
                      disabled={readOnly}
                    />
                    <label className="form-check-label" htmlFor="homicidal_yes">Yes</label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="clinical_homicidal_ideation"
                      id="homicidal_no"
                      value="false"
                      checked={formData.clinical_homicidal_ideation === false || formData.clinical_homicidal_ideation === "false"}
                      onChange={() => setFormData((prev) => ({ ...prev, clinical_homicidal_ideation: false }))}
                      disabled={readOnly}
                    />
                    <label className="form-check-label" htmlFor="homicidal_no">No</label>
                  </div>
                </div>

                <div className="col-md-4">
                  <label className="form-label d-block text-dark fw-semibold mb-2">Impulsivity:</label>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="clinical_impulsivity"
                      id="impulsivity_yes"
                      value="true"
                      checked={formData.clinical_impulsivity === true || formData.clinical_impulsivity === "true"}
                      onChange={() => setFormData((prev) => ({ ...prev, clinical_impulsivity: true }))}
                      disabled={readOnly}
                    />
                    <label className="form-check-label" htmlFor="impulsivity_yes">Yes</label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="clinical_impulsivity"
                      id="impulsivity_no"
                      value="false"
                      checked={formData.clinical_impulsivity === false || formData.clinical_impulsivity === "false"}
                      onChange={() => setFormData((prev) => ({ ...prev, clinical_impulsivity: false }))}
                      disabled={readOnly}
                    />
                    <label className="form-check-label" htmlFor="impulsivity_no">No</label>
                  </div>
                </div>

                <div className="col-md-12">
                  <label className="form-label d-block text-dark fw-semibold mb-2">Risk Level Today:</label>
                  {["Low", "Moderate", "High"].map((level) => (
                    <div key={level} className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="clinical_risk_level"
                        id={`risk_level_${level}`}
                        value={level}
                        checked={formData.clinical_risk_level === level}
                        onChange={handleChange}
                        disabled={readOnly}
                      />
                      <label className="form-check-label" htmlFor={`risk_level_${level}`}>
                        {level}
                      </label>
                    </div>
                  ))}
                </div>

                <div className="col-12">
                  <div className="form-floating form-floating-outline">
                    <textarea
                      className="form-control"
                      name="clinical_risk_action_taken"
                      value={formData.clinical_risk_action_taken || ""}
                      onChange={handleChange}
                      disabled={readOnly}
                      placeholder="If moderate/high, action taken"
                      style={{ height: "80px" }}
                    />
                    <label>If moderate/high, action taken</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* SECTION 5: Medication Review */}
        <div className="accordion-item card mb-3">
          <h2 className="accordion-header" id="headingMeds">
            <button
              className="accordion-button collapsed bg-label-primary text-primary fw-bold"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseMeds"
              aria-expanded="false"
              aria-controls="collapseMeds"
            >
              5. Medication Review
            </button>
          </h2>
          <div
            id="collapseMeds"
            className="accordion-collapse collapse"
            aria-labelledby="headingMeds"
            data-bs-parent="#clinicalRecordAccordion"
          >
            <div className="accordion-body pt-4">
              <div className="row g-3">
                <div className="col-md-6">
                  <label className="form-label d-block text-dark fw-semibold mb-2">Currently on Medication:</label>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="med_currently_on"
                      id="med_currently_on_yes"
                      value="true"
                      checked={formData.med_currently_on === true || formData.med_currently_on === "true"}
                      onChange={() => setFormData((prev) => ({ ...prev, med_currently_on: true }))}
                      disabled={readOnly}
                    />
                    <label className="form-check-label" htmlFor="med_currently_on_yes">Yes</label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="med_currently_on"
                      id="med_currently_on_no"
                      value="false"
                      checked={formData.med_currently_on === false || formData.med_currently_on === "false"}
                      onChange={() => setFormData((prev) => ({ ...prev, med_currently_on: false }))}
                      disabled={readOnly}
                    />
                    <label className="form-check-label" htmlFor="med_currently_on_no">No</label>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating form-floating-outline">
                    <select
                      className="form-select"
                      name="med_adherence"
                      value={formData.med_adherence || ""}
                      onChange={handleChange}
                      disabled={readOnly}
                    >
                      <option value="">Select Adherence Level</option>
                      <option value="Fully compliant">Fully compliant</option>
                      <option value="Partially compliant">Partially compliant</option>
                      <option value="Non-adherent">Non-adherent</option>
                    </select>
                    <label>Medication Adherence</label>
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="form-floating form-floating-outline">
                    <input
                      type="text"
                      className="form-control"
                      name="med_side_effects"
                      value={formData.med_side_effects || ""}
                      onChange={handleChange}
                      disabled={readOnly}
                      placeholder="Side Effects Reported"
                    />
                    <label>Side Effects Reported</label>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating form-floating-outline">
                    <select
                      className="form-select"
                      name="med_changes"
                      value={formData.med_changes || ""}
                      onChange={handleChange}
                      disabled={readOnly}
                    >
                      <option value="">Select Medication Changes Today</option>
                      <option value="Initiated">Initiated</option>
                      <option value="Adjusted">Adjusted</option>
                      <option value="Continued">Continued</option>
                      <option value="Discontinued">Discontinued</option>
                    </select>
                    <label>Medication Changes Today</label>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating form-floating-outline">
                    <input
                      type="text"
                      className="form-control"
                      name="med_prescribed_by"
                      value={formData.med_prescribed_by || ""}
                      onChange={handleChange}
                      disabled={readOnly}
                      placeholder="Prescribed By"
                    />
                    <label>Prescribed By</label>
                  </div>
                </div>

                <div className="col-12">
                  <div className="form-floating form-floating-outline">
                    <textarea
                      className="form-control"
                      name="med_changes_details"
                      value={formData.med_changes_details || ""}
                      onChange={handleChange}
                      disabled={readOnly}
                      placeholder="Details (Drug, Dose, Frequency)"
                      style={{ height: "90px" }}
                    />
                    <label>Details (Drug, Dose, Frequency)</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* SECTION 6: Family Psychoeducation */}
        <div className="accordion-item card mb-3">
          <h2 className="accordion-header" id="headingPsychoedu">
            <button
              className="accordion-button collapsed bg-label-primary text-primary fw-bold"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapsePsychoedu"
              aria-expanded="false"
              aria-controls="collapsePsychoedu"
            >
              6. Family Psychoeducation (30 mins as per SOP)
            </button>
          </h2>
          <div
            id="collapsePsychoedu"
            className="accordion-collapse collapse"
            aria-labelledby="headingPsychoedu"
            data-bs-parent="#clinicalRecordAccordion"
          >
            <div className="accordion-body pt-4">
              <label className="form-label d-block text-dark fw-semibold mb-2">Topics Covered Today:</label>
              <div className="row g-2 mb-3">
                <div className="col-md-6">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="psychoedu_illness_understanding"
                      name="psychoedu_illness_understanding"
                      checked={!!formData.psychoedu_illness_understanding}
                      onChange={handleCheckboxChange}
                      disabled={readOnly}
                    />
                    <label className="form-check-label text-dark" htmlFor="psychoedu_illness_understanding">
                      Illness understanding
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="psychoedu_medication_importance"
                      name="psychoedu_medication_importance"
                      checked={!!formData.psychoedu_medication_importance}
                      onChange={handleCheckboxChange}
                      disabled={readOnly}
                    />
                    <label className="form-check-label text-dark" htmlFor="psychoedu_medication_importance">
                      Medication importance
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="psychoedu_relapse_signs"
                      name="psychoedu_relapse_signs"
                      checked={!!formData.psychoedu_relapse_signs}
                      onChange={handleCheckboxChange}
                      disabled={readOnly}
                    />
                    <label className="form-check-label text-dark" htmlFor="psychoedu_relapse_signs">
                      Relapse signs
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="psychoedu_behavior_management"
                      name="psychoedu_behavior_management"
                      checked={!!formData.psychoedu_behavior_management}
                      onChange={handleCheckboxChange}
                      disabled={readOnly}
                    />
                    <label className="form-check-label text-dark" htmlFor="psychoedu_behavior_management">
                      Behavior management
                    </label>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="psychoedu_communication_strategies"
                      name="psychoedu_communication_strategies"
                      checked={!!formData.psychoedu_communication_strategies}
                      onChange={handleCheckboxChange}
                      disabled={readOnly}
                    />
                    <label className="form-check-label text-dark" htmlFor="psychoedu_communication_strategies">
                      Communication strategies
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="psychoedu_crisis_handling"
                      name="psychoedu_crisis_handling"
                      checked={!!formData.psychoedu_crisis_handling}
                      onChange={handleCheckboxChange}
                      disabled={readOnly}
                    />
                    <label className="form-check-label text-dark" htmlFor="psychoedu_crisis_handling">
                      Crisis handling
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="psychoedu_rehab_readiness"
                      name="psychoedu_rehab_readiness"
                      checked={!!formData.psychoedu_rehab_readiness}
                      onChange={handleCheckboxChange}
                      disabled={readOnly}
                    />
                    <label className="form-check-label text-dark" htmlFor="psychoedu_rehab_readiness">
                      Rehabilitation readiness
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="psychoedu_residential_vs_drp"
                      name="psychoedu_residential_vs_drp"
                      checked={!!formData.psychoedu_residential_vs_drp}
                      onChange={handleCheckboxChange}
                      disabled={readOnly}
                    />
                    <label className="form-check-label text-dark" htmlFor="psychoedu_residential_vs_drp">
                      Residential vs DRP explanation
                    </label>
                  </div>
                </div>
              </div>

              <div className="row g-3">
                <div className="col-md-12">
                  <div className="form-floating form-floating-outline">
                    <select
                      className="form-select"
                      name="psychoedu_family_response"
                      value={formData.psychoedu_family_response || ""}
                      onChange={handleChange}
                      disabled={readOnly}
                    >
                      <option value="">Select Family Response</option>
                      <option value="Cooperative">Cooperative</option>
                      <option value="Anxious">Anxious</option>
                      <option value="Resistant">Resistant</option>
                      <option value="In denial">In denial</option>
                    </select>
                    <label>Family Response</label>
                  </div>
                </div>

                <div className="col-12">
                  <div className="form-floating form-floating-outline">
                    <textarea
                      className="form-control"
                      name="psychoedu_notes"
                      value={formData.psychoedu_notes || ""}
                      onChange={handleChange}
                      disabled={readOnly}
                      placeholder="Psychoeducation Notes"
                      style={{ height: "90px" }}
                    />
                    <label>Notes</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* SECTION 7: Client Engagement Session */}
        <div className="accordion-item card mb-3">
          <h2 className="accordion-header" id="headingEngagement">
            <button
              className="accordion-button collapsed bg-label-primary text-primary fw-bold"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseEngagement"
              aria-expanded="false"
              aria-controls="collapseEngagement"
            >
              7. Client Engagement Session
            </button>
          </h2>
          <div
            id="collapseEngagement"
            className="accordion-collapse collapse"
            aria-labelledby="headingEngagement"
            data-bs-parent="#clinicalRecordAccordion"
          >
            <div className="accordion-body pt-4">
              <div className="row g-3">
                <div className="col-md-6">
                  <div className="form-floating form-floating-outline">
                    <select
                      className="form-select"
                      name="engagement_participation"
                      value={formData.engagement_participation || ""}
                      onChange={handleChange}
                      disabled={readOnly}
                    >
                      <option value="">Select Participation Level</option>
                      <option value="Active">Active</option>
                      <option value="Minimal">Minimal</option>
                      <option value="Resistant">Resistant</option>
                      <option value="Refused">Refused</option>
                    </select>
                    <label>Client Participation Level</label>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating form-floating-outline">
                    <select
                      className="form-select"
                      name="engagement_motivation"
                      value={formData.engagement_motivation || ""}
                      onChange={handleChange}
                      disabled={readOnly}
                    >
                      <option value="">Select Motivation Level</option>
                      <option value="High">High</option>
                      <option value="Moderate">Moderate</option>
                      <option value="Low">Low</option>
                      <option value="Refuses">Refuses</option>
                    </select>
                    <label>Motivation for Rehabilitation</label>
                  </div>
                </div>

                <div className="col-12">
                  <div className="form-floating form-floating-outline">
                    <textarea
                      className="form-control"
                      name="engagement_issues_discussed"
                      value={formData.engagement_issues_discussed || ""}
                      onChange={handleChange}
                      disabled={readOnly}
                      placeholder="Main Issues Discussed"
                      style={{ height: "80px" }}
                    />
                    <label>Main Issues Discussed</label>
                  </div>
                </div>

                <div className="col-12">
                  <div className="form-floating form-floating-outline">
                    <textarea
                      className="form-control"
                      name="engagement_coping_style"
                      value={formData.engagement_coping_style || ""}
                      onChange={handleChange}
                      disabled={readOnly}
                      placeholder="Coping Style Observed"
                      style={{ height: "80px" }}
                    />
                    <label>Coping Style Observed</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* SECTION 8: Goal Setting / Rehabilitation Readiness */}
        <div className="accordion-item card mb-3">
          <h2 className="accordion-header" id="headingGoals">
            <button
              className="accordion-button collapsed bg-label-primary text-primary fw-bold"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseGoals"
              aria-expanded="false"
              aria-controls="collapseGoals"
            >
              8. Goal Setting / Rehabilitation Readiness (Visit 3 onward)
            </button>
          </h2>
          <div
            id="collapseGoals"
            className="accordion-collapse collapse"
            aria-labelledby="headingGoals"
            data-bs-parent="#clinicalRecordAccordion"
          >
            <div className="accordion-body pt-4">
              <div className="row g-3">
                <div className="col-md-6">
                  <div className="form-floating form-floating-outline">
                    <input
                      type="text"
                      className="form-control"
                      name="goals_short_term_1"
                      value={formData.goals_short_term_1 || ""}
                      onChange={handleChange}
                      disabled={readOnly}
                      placeholder="Short-term Goal 1"
                    />
                    <label>Short-term Goal 1</label>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating form-floating-outline">
                    <input
                      type="text"
                      className="form-control"
                      name="goals_short_term_2"
                      value={formData.goals_short_term_2 || ""}
                      onChange={handleChange}
                      disabled={readOnly}
                      placeholder="Short-term Goal 2"
                    />
                    <label>Short-term Goal 2</label>
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="form-floating form-floating-outline">
                    <select
                      className="form-select"
                      name="goals_suitability"
                      value={formData.goals_suitability || ""}
                      onChange={handleChange}
                      disabled={readOnly}
                    >
                      <option value="">Select Rehabilitation Suitability</option>
                      <option value="Residential Program">Residential Program</option>
                      <option value="Day Rehabilitation Program (DRP)">Day Rehabilitation Program (DRP)</option>
                      <option value="OPD Follow-up">OPD Follow-up</option>
                      <option value="Not Suitable">Not Suitable</option>
                      <option value="Further Assessment Needed">Further Assessment Needed</option>
                    </select>
                    <label>Rehabilitation Suitability</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* SECTION 9: Decision & Plan After Visit */}
        <div className="accordion-item card mb-3">
          <h2 className="accordion-header" id="headingPlan">
            <button
              className="accordion-button collapsed bg-label-primary text-primary fw-bold"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapsePlan"
              aria-expanded="false"
              aria-controls="collapsePlan"
            >
              9. Decision & Plan After Visit
            </button>
          </h2>
          <div
            id="collapsePlan"
            className="accordion-collapse collapse"
            aria-labelledby="headingPlan"
            data-bs-parent="#clinicalRecordAccordion"
          >
            <div className="accordion-body pt-4">
              <div className="row g-3">
                <div className="col-md-6">
                  <div className="form-floating form-floating-outline">
                    <select
                      className="form-select"
                      name="plan_decision"
                      value={formData.plan_decision || ""}
                      onChange={handleChange}
                      disabled={readOnly}
                    >
                      <option value="">Select Action/Decision</option>
                      <option value="Continue Home Visits">Continue Home Visits</option>
                      <option value="Refer to TRH Residential">Refer to TRH Residential</option>
                      <option value="Refer to DRP">Refer to DRP</option>
                      <option value="Refer to OPD">Refer to OPD</option>
                      <option value="Terminate Services">Terminate Services</option>
                      <option value="Emergency Intervention Required">Emergency Intervention Required</option>
                    </select>
                    <label>Decision & Plan After Visit</label>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating form-floating-outline">
                    <input
                      type="date"
                      className="form-control"
                      name="plan_next_visit_date"
                      value={formData.plan_next_visit_date || ""}
                      onChange={handleChange}
                      disabled={readOnly}
                    />
                    <label>Next Visit Date (If applicable)</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* SECTION 10: Incident Documentation */}
        <div className="accordion-item card mb-3">
          <h2 className="accordion-header" id="headingIncidents">
            <button
              className="accordion-button collapsed bg-label-primary text-primary fw-bold"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseIncidents"
              aria-expanded="false"
              aria-controls="collapseIncidents"
            >
              10. Incident Documentation (If Any)
            </button>
          </h2>
          <div
            id="collapseIncidents"
            className="accordion-collapse collapse"
            aria-labelledby="headingIncidents"
            data-bs-parent="#clinicalRecordAccordion"
          >
            <div className="accordion-body pt-4">
              <div className="row g-3">
                <div className="col-md-12">
                  <label className="form-label d-block text-dark fw-semibold mb-2">Any aggression / disruption during visit:</label>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="incident_aggression_disruption"
                      id="incident_aggression_yes"
                      value="true"
                      checked={formData.incident_aggression_disruption === true || formData.incident_aggression_disruption === "true"}
                      onChange={() => setFormData((prev) => ({ ...prev, incident_aggression_disruption: true }))}
                      disabled={readOnly}
                    />
                    <label className="form-check-label" htmlFor="incident_aggression_yes">Yes</label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="incident_aggression_disruption"
                      id="incident_aggression_no"
                      value="false"
                      checked={formData.incident_aggression_disruption === false || formData.incident_aggression_disruption === "false"}
                      onChange={() => setFormData((prev) => ({ ...prev, incident_aggression_disruption: false }))}
                      disabled={readOnly}
                    />
                    <label className="form-check-label" htmlFor="incident_aggression_no">No</label>
                  </div>
                </div>

                <div className="col-12">
                  <div className="form-floating form-floating-outline">
                    <textarea
                      className="form-control"
                      name="incident_description"
                      value={formData.incident_description || ""}
                      onChange={handleChange}
                      disabled={readOnly}
                      placeholder="Description"
                      style={{ height: "80px" }}
                    />
                    <label>Description</label>
                  </div>
                </div>

                <div className="col-12">
                  <div className="form-floating form-floating-outline">
                    <textarea
                      className="form-control"
                      name="incident_action_taken"
                      value={formData.incident_action_taken || ""}
                      onChange={handleChange}
                      disabled={readOnly}
                      placeholder="Action Taken"
                      style={{ height: "80px" }}
                    />
                    <label>Action Taken</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* SECTION 11: Overall Clinical Impression */}
        <div className="accordion-item card mb-3">
          <h2 className="accordion-header" id="headingImpression">
            <button
              className="accordion-button collapsed bg-label-primary text-primary fw-bold"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseImpression"
              aria-expanded="false"
              aria-controls="collapseImpression"
            >
              11. Overall Clinical Impression
            </button>
          </h2>
          <div
            id="collapseImpression"
            className="accordion-collapse collapse"
            aria-labelledby="headingImpression"
            data-bs-parent="#clinicalRecordAccordion"
          >
            <div className="accordion-body pt-4">
              <div className="row g-3">
                <div className="col-12">
                  <div className="form-floating form-floating-outline">
                    <textarea
                      className="form-control"
                      name="impression_summary"
                      value={formData.impression_summary || ""}
                      onChange={handleChange}
                      disabled={readOnly}
                      placeholder="Summary of Today's Visit"
                      style={{ height: "90px" }}
                    />
                    <label>Summary of Today's Visit</label>
                  </div>
                </div>

                <div className="col-md-12">
                  <label className="form-label d-block text-dark fw-semibold mb-2">Progress Since Last Visit:</label>
                  {["Improved", "Same", "Deteriorated"].map((progress) => (
                    <div key={progress} className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="impression_progress"
                        id={`impression_progress_${progress}`}
                        value={progress}
                        checked={formData.impression_progress === progress}
                        onChange={handleChange}
                        disabled={readOnly}
                      />
                      <label className="form-check-label" htmlFor={`impression_progress_${progress}`}>
                        {progress}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* SECTION 12: Finance Information */}
        <div className="accordion-item card mb-3">
          <h2 className="accordion-header" id="headingFinance">
            <button
              className="accordion-button collapsed bg-label-primary text-primary fw-bold"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseFinance"
              aria-expanded="false"
              aria-controls="collapseFinance"
            >
              12. Finance Information
            </button>
          </h2>
          <div
            id="collapseFinance"
            className="accordion-collapse collapse"
            aria-labelledby="headingFinance"
            data-bs-parent="#clinicalRecordAccordion"
          >
            <div className="accordion-body pt-3">
              <div className="row g-3">
                <div className="col-md-3">
                  <div className="form-floating form-floating-outline mb-3">
                    <input
                      type="text"
                      className="form-control"
                      name="amount"
                      value={formData.amount || ""}
                      onChange={handleChange}
                      placeholder="Amount"
                      disabled={readOnly}
                    />
                    <label>Amount</label>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-floating form-floating-outline mb-3">
                    <select
                      className="form-select"
                      name="payment_status"
                      value={formData.payment_status || ""}
                      onChange={handleChange}
                      disabled={readOnly}
                    >
                      <option value="">Select Status</option>
                      <option value="Paid">Paid</option>
                      <option value="unpaid">Unpaid</option>
                    </select>
                    <label>Payment Status</label>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-floating form-floating-outline mb-3">
                    <input
                      type="text"
                      className="form-control"
                      name="reference_no"
                      value={formData.reference_no || ""}
                      onChange={handleChange}
                      placeholder="Reference No"
                      disabled={readOnly}
                    />
                    <label>Reference No</label>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-floating form-floating-outline mb-3">
                    <input
                      type="date"
                      className="form-control"
                      name="payment_date"
                      value={formData.payment_date ? formData.payment_date.substring(0, 10) : ""}
                      onChange={handleChange}
                      disabled={readOnly}
                    />
                    <label>Payment Date</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* SECTION 13: Quality Tracking & Signatures */}
        <div className="accordion-item card mb-3">
          <h2 className="accordion-header" id="headingSignatures">
            <button
              className="accordion-button collapsed bg-label-primary text-primary fw-bold"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseSignatures"
              aria-expanded="false"
              aria-controls="collapseSignatures"
            >
              13. Quality Audit & Signatures
            </button>
          </h2>
          <div
            id="collapseSignatures"
            className="accordion-collapse collapse"
            aria-labelledby="headingSignatures"
            data-bs-parent="#clinicalRecordAccordion"
          >
            <div className="accordion-body pt-4">
              <h6 className="text-secondary border-bottom pb-2 fw-semibold">Optional Add-On (For Quality & Audit Tracking)</h6>
              <div className="row g-2 mb-4">
                <div className="col-md-12">
                  <div className="form-check mb-2">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="audit_completed_within_1hour"
                      name="audit_completed_within_1hour"
                      checked={!!formData.audit_completed_within_1hour}
                      onChange={handleCheckboxChange}
                      disabled={readOnly}
                    />
                    <label className="form-check-label text-dark" htmlFor="audit_completed_within_1hour">
                      Visit completed within 1-hour standard
                    </label>
                  </div>

                  <div className="form-check mb-2">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="audit_documentation_same_day"
                      name="audit_documentation_same_day"
                      checked={!!formData.audit_documentation_same_day}
                      onChange={handleCheckboxChange}
                      disabled={readOnly}
                    />
                    <label className="form-check-label text-dark" htmlFor="audit_documentation_same_day">
                      Documentation completed same day
                    </label>
                  </div>

                  <div className="form-check mb-2">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="audit_medication_chart_updated"
                      name="audit_medication_chart_updated"
                      checked={!!formData.audit_medication_chart_updated}
                      onChange={handleCheckboxChange}
                      disabled={readOnly}
                    />
                    <label className="form-check-label text-dark" htmlFor="audit_medication_chart_updated">
                      Medication chart updated
                    </label>
                  </div>

                  <div className="form-check mb-2">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="audit_risk_reassessment_completed"
                      name="audit_risk_reassessment_completed"
                      checked={!!formData.audit_risk_reassessment_completed}
                      onChange={handleCheckboxChange}
                      disabled={readOnly}
                    />
                    <label className="form-check-label text-dark" htmlFor="audit_risk_reassessment_completed">
                      Risk reassessment completed
                    </label>
                  </div>
                </div>
              </div>

              <h6 className="text-secondary border-bottom pb-2 fw-semibold">Signatures</h6>
              <div className="row g-3">
                <div className="col-md-6">
                  <div className="form-floating form-floating-outline">
                    <input
                      type="text"
                      className="form-control"
                      name="signature_psychiatrist"
                      value={formData.signature_psychiatrist || ""}
                      onChange={handleChange}
                      disabled={readOnly}
                      placeholder="Psychiatrist Signature"
                    />
                    <label>Psychiatrist Name / Signature</label>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating form-floating-outline">
                    <input
                      type="date"
                      className="form-control"
                      name="signature_psychiatrist_date"
                      value={formData.signature_psychiatrist_date || ""}
                      onChange={handleChange}
                      disabled={readOnly}
                    />
                    <label>Psychiatrist Signature Date</label>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating form-floating-outline">
                    <input
                      type="text"
                      className="form-control"
                      name="signature_rehab_practitioner"
                      value={formData.signature_rehab_practitioner || ""}
                      onChange={handleChange}
                      disabled={readOnly}
                      placeholder="Rehab Practitioner Signature"
                    />
                    <label>Rehabilitation Practitioner Name / Signature</label>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating form-floating-outline">
                    <input
                      type="text"
                      className="form-control"
                      name="signature_family_member"
                      value={formData.signature_family_member || ""}
                      onChange={handleChange}
                      disabled={readOnly}
                      placeholder="Family Member Signature"
                    />
                    <label>Family Member Name / Signature</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default HomeVisitClinicalRecordForm;
